import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'
import type {
  IPortfolioTransactionsOkResponse,
  IPortfolioTransactionsRequest,
} from '~/@api/generated-api-types-account/Api'
import type { TransactionType } from '../_transaction_types/transaction.types'
import {
  defaultPaginationParams,
  infiniteQueryNextPageParam,
} from '~/@mid_query/utils/pagination.utils'

export function useTransactionsQuery({
  project,
  transactionId,
  startDate,
  endDate,
}: {
  project?: { businessId?: number; stageNumber?: number }
  transactionId: TransactionType | 'all'
  startDate: Date
  endDate: Date
}) {
  const client = useApiClientAccount()

  async function fetchTransactions(args: IPortfolioTransactionsRequest) {
    return client.account
      .portfolioControllerGetTransactions(args, {
        secure: true,
      })
      .then((resp) => resp.data)
  }

  const startDateISO = startDate.toISOString()
  const endDateISO = endDate.toISOString()

  return useInfiniteQuery({
    queryKey: [
      'transactions',
      project?.businessId,
      project?.stageNumber,
      transactionId,
      startDateISO,
      endDateISO,
    ],
    queryFn: ({ pageParam = 0 }) =>
      fetchTransactions({
        filter: {
          ...(transactionId !== 'all' && { types: [transactionId] }),
          project,
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        },
        ...defaultPaginationParams(pageParam),
      }),
    getNextPageParam:
      infiniteQueryNextPageParam<IPortfolioTransactionsOkResponse>,
    initialPageParam: 0,
    // throwOnError: true,
    placeholderData: keepPreviousData,
  })
}
